import {
    DASHBOARD_YEAR_FILTER,
    DASHBOARD_QUARTER_FILTER,
    DASHBOARD_MONTH_FILTER,
    DASHBOARD_SEARCH_TRIGGER
} from '../constants/ActionTypes';
import { quarterData, monthData } from '../utils/DateObject';

let dt = new Date();
let year = dt.getFullYear()
let month = dt.getMonth()+1;

let currentYear = {value: year, label: year};
let currentMonth = monthData.find( m => m.value === month);
let currentQuarter = quarterData.find( q => q.value === Math.ceil(month/3))

const initialState = {
    yearSelected: currentYear,
    qtrSelected: currentQuarter,
    monthSelected: currentMonth,
    searchTrigger: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case DASHBOARD_YEAR_FILTER:
            return {
                ...state,
                yearSelected: action.payload,
            }
        case DASHBOARD_QUARTER_FILTER:
            return {
                ...state,
                qtrSelected: action.payload,
            }
        case DASHBOARD_MONTH_FILTER:
            return {
                ...state,
                monthSelected: action.payload,
            }
        case DASHBOARD_SEARCH_TRIGGER:
            return {
                ...state,
                searchTrigger: state.searchTrigger + 1,
            }
        default:
            return state;
    }
}